'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Badge = _interopDefault(require('@material-ui/core/Badge'));
var styledComponents = require('./styled-components.js');

var HorizontalTab = function (_a) {
    var labels = _a.labels, reporter = _a.reporter, value = _a.value, indicatorColor = _a.indicatorColor, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.errorTabs, errorTabs = _d === void 0 ? [] : _d, _e = _a.scrollable, scrollable = _e === void 0 ? false : _e;
    var _f = React__default.useState(value !== null && value !== void 0 ? value : 0), localValue = _f[0], setLocalValue = _f[1];
    React.useEffect(function () {
        setLocalValue(value !== null && value !== void 0 ? value : localValue);
    }, [value]);
    var handleChange = function (event, newValue) {
        if (reporter) {
            reporter(event, newValue);
        }
        setLocalValue(newValue);
    };
    var TabLabel = function (_a) {
        var label = _a.label;
        if (errorTabs.length > 0 && errorTabs.includes(label)) {
            return (React__default.createElement(Badge, { style: { marginRight: '5px' }, color: 'error', variant: 'dot' }, label));
        }
        return React__default.createElement("span", null, label);
    };
    var variant = scrollable ? 'scrollable' : undefined;
    var scrollButtons = scrollable ? 'auto' : undefined;
    return (React__default.createElement(styledComponents.StyledTabs, { value: localValue, indicatorColor: 'primary', textColor: 'primary', onChange: handleChange, "aria-label": 'disabled tabs example', TabIndicatorProps: {
            style: {
                backgroundColor: indicatorColor,
            },
        }, className: className, style: style, variant: variant, scrollButtons: scrollButtons }, labels.map(function (label) {
        if (typeof label === 'string') {
            return React__default.createElement(styledComponents.StyledTab, { key: label, label: React__default.createElement(TabLabel, { label: label }), disableRipple: true });
        }
        return (React__default.createElement(styledComponents.StyledIconTab, { key: label.text, label: React__default.createElement(TabLabel, { label: label.text }), disableRipple: true, icon: label.icon }));
    })));
};

module.exports = HorizontalTab;
